export default "__VITE_ASSET__dc49aded__"